export const profileNavTabs = Object.freeze({
	Profile: "profile",
	Security: "security",
	Iam: "iam",
	Logins: "logins",
	SubjectGroups: "subjectGroups",
	Courier: "courier",
	Library: "library",
});
